import { render, staticRenderFns } from "./fetchError.vue?vue&type=template&id=72891aec&scoped=true&"
import script from "./fetchError.vue?vue&type=script&lang=js&"
export * from "./fetchError.vue?vue&type=script&lang=js&"
import style0 from "./fetchError.vue?vue&type=style&index=0&id=72891aec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72891aec",
  null
  
)

export default component.exports